<template>
    <Modal v-model:open="isOpen" :title="$t('pages.product_detail_page.product_info.product_button.new_project_modal.title')" no-footer size="sm">
        <div class="flex flex-col gap-5 px-3 pb-3">
            <p class="text-sm text-black/60">
                {{ $t('pages.product_detail_page.product_info.product_button.new_project_modal.description') }}
            </p>

            <div class="flex flex-col gap-1">
                <Input
                    v-model="projectTitle"
                    name="project-title"
                    maxlength="150"
                    :label="$t('pages.product_detail_page.product_info.product_button.new_project_modal.title_label')"
                    :placeholder="
                        $t('pages.product_detail_page.product_info.product_button.new_project_modal.title_placeholder', { year: currentYear })
                    "
                    autofocus
                    @on-enter="onStart"
                />
                <p class="text-right text-xs text-black/40">
                    {{
                        $t('pages.product_detail_page.product_info.product_button.new_project_modal.title_hint', {
                            count: (projectTitle ?? '').length,
                        })
                    }}
                </p>
            </div>

            <Button
                task="startOrdering"
                :label="$t('pages.product_detail_page.product_info.product_button.new_project_modal.submit')"
                no-icon
                @click="onStart"
            />
        </div>
    </Modal>
</template>

<script setup lang="ts">
import Button from '@/components/buttons/Button.vue';
import Input from '@/components/forms/inputs/Input.vue';
import Modal from '@/components/modals/Modal.vue';
import { ref, watch } from 'vue';

const isOpen = defineModel<boolean>();

const emits = defineEmits<{
    start: [title: string | undefined];
}>();

const projectTitle = ref<string | undefined>(undefined);
const currentYear = new Date().getFullYear();

watch(isOpen, value => {
    if (!value) {
        return;
    }

    projectTitle.value = undefined;
});

function onStart(): void {
    isOpen.value = false;
    emits('start', projectTitle.value?.trim() || undefined);
}
</script>
